<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="row">
        <div class="col-xs-6">
          <h1>All Push Requests</h1>
        </div>
      </div>
    </section>
    <section class="content">
      <div class="row form">
        <div class="col-xs-6 col-sm-2 form-group">
          <select
            title=""
            name="status"
            id="status"
            v-model="status"
            v-select="status"
            class="form-control input-sm select2"
            @change="filterPushList()"
          >
            <option value="">All</option>
            <option value="1">Succeed</option>
            <option value="2">Failed by api</option>
            <option value="3">Users not found</option>
          </select>
        </div>
        <div class="col-xs-6 col-sm-2 form-group">
          <select
            title=""
            name="limit"
            id="limit"
            v-model="display_limit"
            v-select="display_limit"
            class="form-control input-sm select2"
            @change="dopagination(0)"
          >
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="75">75</option>
            <option value="100">100</option>
            <option value="500">500</option>
            <option value="1000">1000</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="box" id="pagination">
            <div class="box-header">
              <h3 class="box-title">
                Total : {{ totalData }} Showing {{ dispplayFrom }} to
                {{ dispplayTo }}
                <span class="pull-right noOfData">{{ totalData }}</span>
              </h3>
            </div>
            <div class="box-body">
              <div class="table-responsive">
                <table class="table table-0024 table-bordered table-striped">
                  <thead>
                    <tr>
                      <th class="tdCenter tdSN">SN</th>
                      <th class="tdCenter">Push Title</th>
                      <th class="tdCenter">Push Message</th>
                      <th class="tdCenter">Status</th>
                      <th class="tdCenter">Time and Date</th>
                      <th class="tdCenter">Targeted User</th>
                      <th class="tdCenter" width="200">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in pushList" :key="data.id">
                      <td class="tdCenter tdSN">{{ parseInt(sl) + index }}</td>
                      <td class="">{{ data.headings }}</td>
                      <td class="">{{ data.push_message }}</td>
                      <td
                        :class="{
                          'status-succeed': data.success_status == 1,
                          'status-user-not-found': data.success_status == 3,
                          'status-failed':
                            data.success_status !== 1 &&
                            data.success_status !== 3,
                        }"
                      >
                        {{
                          data.success_status == 1
                            ? "Succeed"
                            : data.success_status == 3
                            ? "Users not found"
                            : "Failed by API"
                        }}
                      </td>

                      <td class="">
                        {{
                          new Date(data.created_at).toLocaleString("en-US", {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                          })
                        }}
                      </td>
                      <td class="tdCenter">
                        <button
                          type="submit"
                          class="btn btn-xs btn-warning"
                          @click="viewPushUserList(data.id)"
                        >
                          <i class="fa fa-list"></i>
                          View Details
                        </button>
                      </td>
                      <td class="tdCenter">
                        <button
                          title="Resend"
                          @click="resendPush(data.id , data.success_status)"
                          class="btn btn-sm btn-warning btn-sm2"
                          style="padding: 1px 2px"
                        >
                          <i class="fa fa-retweet"> </i> Resend
                        </button>
                      </td>
                    </tr>

                    <tr v-if="totalData == 0">
                      <td colspan="12" class="tdCenter" style="padding: 30px 0">
                        <b>No Records Found</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="pagination" v-if="last_page > 1">
              <a
                v-if="prev_page_url"
                href="#"
                @click="dopagination(prevPage)"
                class="next"
              >
                « Previous
              </a>
              <span v-else class="disabled">« Previous</span>
              <span v-if="last_page > max_display_pagination">
                <span v-for="index in last_page">
                  <span v-if="index == 1 || index == 2">
                    <span class="current" v-if="index == current_page">
                      {{ index }}
                    </span>
                    <span v-else>
                      <a href="#" @click="dopagination(index)">
                        {{ index }}
                      </a>
                    </span>
                    <span v-if="index == 2 && firstDotted">..</span>
                  </span>
                  <span v-if="randomPageNumber.includes(index)">
                    <span class="current" v-if="index == current_page">
                      {{ index }}
                    </span>
                    <span v-else>
                      <a href="#" @click="dopagination(index)">
                        {{ index }}
                      </a>
                    </span>
                  </span>
                  <span v-if="index == last_page || index == last_page - 1">
                    <span v-if="index == last_page - 1 && lastDotted">
                      ..
                    </span>
                    <span class="current" v-if="index == current_page">
                      {{ index }}
                    </span>
                    <span v-else>
                      <a href="#" @click="dopagination(index)">
                        {{ index }}
                      </a>
                    </span>
                  </span>
                </span>
              </span>
              <span v-else>
                <span v-for="index in last_page">
                  <span class="current" v-if="index == current_page">
                    {{ index }}
                  </span>
                  <span v-else>
                    <a href="#" @click="dopagination(index)">{{ index }}</a>
                  </span>
                </span>
              </span>
              <a
                v-if="next_page_url"
                href="#"
                @click="dopagination(nextPage)"
                class="next"
              >
                Next »
              </a>
              <span v-else class="disabled">Next »</span>
            </div>
            <div class="box-footer">
              <input
                type="hidden"
                name="limit"
                id="limit"
                value="<?php echo $limit ?>"
              />
              <input
                type="hidden"
                name="startoffset"
                id="startoffset"
                value="<?php echo $startoffset ?>"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade"
        id="pushUserListModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="pushUserListModalTitle"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLongTitle">
                Push User List
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <table class="table table-0024 table-bordered table-striped">
                <thead>
                  <tr>
                    <th class="tdCenter tdSN">SN</th>
                    <th class="tdCenter">Username</th>
                    <th class="tdCenter">Country</th>
                    <th class="tdCenter">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in targetedUserList" :key="data.id">
                    <td class="tdCenter tdSN">{{ index + 1 }}</td>
                    <td class="">{{ data.username }}</td>
                    <td class="">{{ data.country }}</td>
                    <td class="">
                      {{
                        data.status == 1
                          ? "Active"
                          : data.status == 2
                          ? "Inactive"
                          : "Expired"
                      }}
                    </td>
                  </tr>
                  <tr v-if="targetedUserList.length == 0">
                    <td colspan="12" class="tdCenter" style="padding: 30px 0">
                      <b>No Records Found</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import axios from "axios";
// import { reduce } from "core-js/core/array";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    vSelect,
  },
  name: "AllPushRequests",
  data() {
    return {
      pushList: [],
      dispplayFrom: 0,
      dispplayTo: 0,
      display_limit: 50,
      totalData: 0,
      prev_page_url: false,
      next_page_url: false,
      last_page: 1,
      current_page: null,
      max_display_pagination: 9,
      randomPageNumber: {},
      firstDotted: false,
      lastDotted: false,
      prevPage: "",
      nextPage: "",
      targetedUserList: [],
      status: "1",
    };
  },
  mounted() {
    $(".select2").select2();
  },
  created() {
    this.filterPushList();
  },
  methods: {
    // loadPushList() {
    //   loader.show();
    //   axios
    //     .get("/get-push-list")
    //     .then((response) => {
    //       if (response.data.result?.toLowerCase() == "success") {
    //         this.populatePushListData(response.data);
    //       }
    //       loader.hide();
    //     })
    //     .catch((error) => {
    //       loader.hide();
    //       console.log(error);
    //     });
    // },
    dopagination(page_no = "") {
      loader.show();
      var rootObject = this;

      let querystr = "paginate=" + this.display_limit;
      if (this.status) {
        querystr += "&status=" + this.status;
      }
      if (page_no > 0) {
        querystr += "&page=" + page_no;
      } else {
        querystr += "&page=1";
      }

      axios
        .get("/get-push-list?" + querystr)
        .then(function (response) {
          rootObject.populatePushListData(response?.data);
        })
        .catch(function (error) {
          let alertmessage = "";
          for (var prop in error.response.data) {
            alertmessage += " " + error.response.data[prop];
          }

          loader.hide();
          rootObject.com_errorHandel(error);
        });
    },
    populatePushListData(response) {
      this.sl = parseInt(response.data.from);
      this.pushList = response.data.data;
      this.totalData = response.data.total;
      this.dispplayFrom = response.data.from;
      this.dispplayTo = response.data.to;
      this.display_limit = response.data.per_page;
      this.paginationGenerate(response);
      loader.hide();
    },
    paginationGenerate(response) {
      this.prev_page_url = response.data.prev_page_url;
      this.next_page_url = response.data.next_page_url;
      this.last_page = response.data.last_page;
      this.current_page = response.data.current_page;
      this.randomPageNumber = [];
      this.firstDotted = false;
      this.lastDotted = false;
      this.prevPage = this.current_page - 1;
      this.nextPage = this.current_page + 1;
      let countableOtherPages = this.max_display_pagination - 4;
      if (this.current_page == 1 || this.current_page == 2) {
        for (let i = 3; i <= 3 + (countableOtherPages - 1); i++) {
          this.randomPageNumber.push(i);
        }
        this.lastDotted = true;
      } else if (
        this.current_page == this.last_page ||
        this.current_page == this.last_page - 1
      ) {
        let endPage = this.last_page - 2;
        for (let i = endPage; i >= endPage - (countableOtherPages - 1); i--) {
          this.randomPageNumber.push(i);
        }
        this.firstDotted = true;
      } else {
        let interval = parseInt(countableOtherPages / 2);
        if (this.current_page <= interval + 3) {
          for (let i = 3; i <= 3 + (countableOtherPages - 1); i++) {
            this.randomPageNumber.push(i);
          }
          this.lastDotted = true;
        } else if (this.current_page >= this.last_page - (interval + 2)) {
          let endPage = this.last_page - 2;
          for (let i = endPage; i >= endPage - (countableOtherPages - 1); i--) {
            this.randomPageNumber.push(i);
          }
          this.firstDotted = true;
        } else {
          for (
            let i = this.current_page;
            i <= this.current_page + interval;
            i++
          ) {
            this.randomPageNumber.push(i);
          }

          for (
            let i = this.current_page - 1;
            i >= this.current_page - interval;
            i--
          ) {
            this.randomPageNumber.push(i);
          }
        }
      }
      //console.log(this.randomPageNumber);
    },
    resendPush(id , status) {
      var rootObject = this;
      var msg = "Are you sure you want to resend this push notification?";
      if(status == 3){
        msg = "This push notification has no users to send! Please check view details";
        $.alert(msg);
        return;
      }

      $.confirm({
        title: "Confirm!",
        content: msg,
        buttons: {
          yes: function () {
            loader.show();

            var config = {
              headers: { "Content-Type": "multipart/form-data" },
            };
            var form = new FormData();
            form.append("id", id);
            axios
              .post("/resend-push", form, config)
              .then(function (response) {
                if (response.data.status_code == 200) {
                  rootObject.filterPushList();
                }
                loader.hide();
              })
              .catch(function (error) {
                rootObject.com_errorHandel(error);
                let alertmessage = "";
                for (var prop in error.response.data) {
                  alertmessage += " " + error.response.data[prop];
                }
                //console.log(alertmessage);
                loader.hide();
                $.alert(alertmessage);
              });
          },
          no: function () {
            return;
          },
        },
      });
    },
    viewPushUserList(id) {
      loader.show();
      var id = id;
      axios
        .post("/get-push-user-list", {
          id: id,
        })
        .then((response) => {
          this.targetedUserList = response.data.data;
          $("#pushUserListModal").modal("show");
          loader.hide();
        })
        .catch((error) => {
          console.log(error);
          loader.hide();
        });
    },
    filterPushList() {
      let querystr = "paginate=" + this.display_limit;
      if (this.status) {
        querystr += "&status=" + this.status;
      }

      loader.show();
      axios
        .get("/get-push-list?" + querystr)
        .then((response) => {
          this.populatePushListData(response.data);
        })
        .catch((error) => {
          loader.hide();
        });
    },
  },
};
</script>

<style scoped>
.text-danger {
  color: red;
}
.status-succeed {
  color: #28a745; /* Green for success */
  font-weight: bold;
}

.status-user-not-found {
  color: #ffc107; /* Yellow for user not found */
  font-weight: bold;
}

.status-failed {
  color: #dc3545; /* Red for failure */
  font-weight: bold;
}

</style>
